export const workshops = [
  {
    key: 6,
    code: "ml",
    title: "SEMINAR ON MACHINE LEARNING",
    details:
      'An amazing seminar on Machine Learning by Mr. Ankit Kariryaa (ML consultant for NASA). The seminar gave students insights on "Detection of Individual Tress at a very large scale".',
    images: [
      require("../assets/gallery/ml/ml1.jpg"),
      require("../assets/gallery/ml/ml2.jpg"),
      require("../assets/gallery/ml/ml3.jpg"),
      require("../assets/gallery/ml/ml4.jpg"),
      require("../assets/gallery/ml/ml5.jpg")
    ]
  },
  {
    key: 5,
    code: "ar",
    title: "AUGMENTED REALITY",
    details:
      "ACM-W BVP presented a hands-on session on Augmented Reality for students of various colleges across all branches. The students were taught AR right from beginning to building a complete AR project. The session received an overwhelming response from students of various colleges.",
    images: [
      require("../assets/gallery/ar/ar1.jpg"),
      require("../assets/gallery/ar/ar2.jpg"),
      require("../assets/gallery/ar/ar3.jpg"),
      require("../assets/gallery/ar/ar4.jpg"),
      require("../assets/gallery/ar/ar5.jpg")
    ]
  },
  {
    key: 4,
    code: "android",
    title: "ANDROID DEVELOPMENT",
    details:
      "Two sessions on ANDROID DEVELOPMENT was an interactive one! The students learned how to implement various layouts, add different views and viewgroups, and make an app interactive by adding onClick method.",
    images: [
      require("../assets/gallery/android/android1.jpg"),
      require("../assets/gallery/android/android2.jpg"),
      require("../assets/gallery/android/android3.jpg"),
      require("../assets/gallery/android/android4.jpg"),
      require("../assets/gallery/android/android5.jpg"),
      require("../assets/gallery/android/android6.jpg")
    ]
  },
  {
    key: 3,
    code: "hs",
    title: "SESSION ON HIGHER STUDIES",
    details:
      "An amazing seminar in collaboration with Made Easy (IES-MADE EASY) by SUNEEL TIWARI Sir. The session gave students insights on career options available to them after college, and how to crack exams like GATE, IES & PSU in very first attempt.",
    images: [
      require("../assets/gallery/hs/hs1.jpg"),
      require("../assets/gallery/hs/hs2.jpg"),
      require("../assets/gallery/hs/hs3.jpg"),
      require("../assets/gallery/hs/hs4.jpg")
    ]
  },
  {
    key: 2,
    code: "webDev",
    title: "WEB DEVELOPMENT",
    details:
      "Four sessions on JavaScript was conducted and attendees understood the core concepts of JavaScript and practical implementation of it.",
    images: [
      require("../assets/gallery/webDev/webd1.jpg"),
      require("../assets/gallery/webDev/webd2.jpg"),
      require("../assets/gallery/webDev/webd3.jpg"),
      require("../assets/gallery/webDev/webd4.jpg"),
      require("../assets/gallery/webDev/webd5.jpg"),
      require("../assets/gallery/webDev/webd6.jpg"),
      require("../assets/gallery/webDev/webd7.jpg")
    ]
  },
  {
    key: 1,
    code: "hoc",
    title: "HOUR OF CODE",
    details:
      "ACM team was teaching the students of 5th standard the basics of programming and logic building, and quite surprising to see how quickly they were able to grasp the concepts.",
    images: [
      require("../assets/gallery/hoc/hoc1.jpg"),
      require("../assets/gallery/hoc/hoc2.jpg"),
      require("../assets/gallery/hoc/hoc3.jpg"),
      require("../assets/gallery/hoc/hoc4.jpg"),
      require("../assets/gallery/hoc/hoc5.jpg"),
      require("../assets/gallery/hoc/hoc6.jpg"),
      require("../assets/gallery/hoc/hoc7.jpg")
    ]
  }
];
